<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Purchasing<span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/msupplier/index"> Manage Supplier  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Create Supplier  </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
                <div class="container-fluid">
                <div class="card bdr-rad2 mt-1 shadow p-2">
                <div class="card-body custom_bdr_rds">


                    <form @submit.prevent="SaveCustomer()" >

<div class="row">
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Supplier Name</label>
            <input  v-model="all_data.sup_name"  style="font-size: small;" class="form-control" >
          
    </div>
  </div>
  
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Supplier Reference </label>
            <input  v-model="all_data.sup_reference"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Supplier Contact</label>
            <input  v-model="all_data.sup_contact"  style="font-size: small;" class="form-control" required>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Tel.</label>
            <input  v-model="all_data.tel"  style="font-size: small;" class="form-control" >
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Supplier Address Line 1 </label>
           
            <input  v-model="all_data.sup_address_1"  style="font-size: small;" class="form-control" required>
    </div>
  </div>
  
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Supplier Address Line 2 </label>
            <input  v-model="all_data.sup_address_2"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Supplier Address Line 3</label>
            <input  v-model="all_data.sup_address_3"  style="font-size: small;" class="form-control" >
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Supplier Address Line 4</label>
            <input  v-model="all_data.sup_address_4"  style="font-size: small;" class="form-control" >
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-3 ">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Currency</label>
            <v-select class="font-size_def" label="discription"  v-model="all_data.sup_currency" :options="currencies" ></v-select>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Country</label>
            <v-select class="font-size_def" label="countryname"  v-model="all_data.country" :options="countries" ></v-select>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Email</label>
            <input  v-model="all_data.email"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">City</label>
            <input  v-model="all_data.city"  style="font-size: small;" class="form-control" >
    </div>
  </div>
</div>


<div class="row">
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Special Notes</label>
            <input  v-model="all_data.special_notes"  style="font-size: small;" class="form-control" >
    </div>
  </div>
  
</div>










   
    

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Update</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
           <br><br>
            </div>
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadSalespeople();
    this.loadupdateData();
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            'id':this.$route.query.id,
            count: 0,
        total:0,
        selectedOption: null, // Store the selected option
     

      salespeoples:[

      ],
        customer:{},
        all_data:{},
        currencies:[],
        countries:[],
      
        detail:[
      {},  
      ],
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },

        methods : {



            async loadupdateData() {
       
     
       try {
         const { data} = await  axios.get('/msupplier/loadupdatedata?id='+this.id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.all_data = data.all_data;
         
         
       } catch (error) {
         console.log(error.response);
       }
     },
 
    

          async loadSalespeople() {
       
     
      try {
        const { data} = await  axios.get('/msupplier/loadcurrency',{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.currencies = data.currency;
         this.countries = data.countries;
        
      } catch (error) {
        console.log(error.response);
      }
    },

    async SaveCustomer() {
       
      
    console.log("amila");
       try {
         const { data} = await  axios.post('/msupplier/update?id='+this.id,{userid:this.userid,all_data:this.all_data},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data.status==200){
          this.$router.push('/msupplier/index');
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
     },
       

     

    },
    
    }
    
    </script>

    <style >
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    